import { render, staticRenderFns } from "./AdapterPkg.vue?vue&type=template&id=df5d374c&"
import script from "./AdapterPkg.vue?vue&type=script&lang=js&"
export * from "./AdapterPkg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports